// extracted by mini-css-extract-plugin
export default {"col":"index_col_x-mTY","mid_gy":"index_mid_gy_NSTLp","mid_gy_left":"index_mid_gy_left_kSOwS","current":"index_current_0nRoN","mid_gy_right":"index_mid_gy_right_NRkWi"};